/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_CopyrightInputs */

const en_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albion.Build © All Rights Reserved`)
};

const es_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albion.Build © Todos los derechos reservados`)
};

/**
* | output |
* | --- |
* | "Albion.Build © All Rights Reserved" |
*
* @param {Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const footer_copyright = /** @type {((inputs?: Footer_CopyrightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CopyrightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_copyright(inputs)
	return en_footer_copyright(inputs)
});
export { footer_copyright as "footer.copyright" }